<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "How often do you hang glide?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideHowOften`,
					props: {
						suggest: {
							typeIncludes: `hangGlideHowOften`
						},
						createOptions: {
							type: `hangGlideHowOften`,
							dataType: "string"
						}
					}
				},
				{
					label: "Where do you hang glide?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideLocation`,
					props: {
						suggest: {
							typeIncludes: `hangGlideLocation`
						},
						createOptions: {
							type: `hangGlideLocation`,
							dataType: "string"
						}
					}
				},
				{
					label: "Are you a member of an organized club?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfHangGlideClub`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfHangGlideClub`
						},
						createOptions: {
							type: `isMemberOfHangGlideClub`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Do you hang glide professionally?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isProHangGlide`,
					props: {
						suggest: {
							typeIncludes: `isProHangGlide`
						},
						createOptions: {
							type: `isProHangGlide`,
							dataType: "boolean"
						}
					}
				},

				{
					label: "How high do you fly?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideHowHigh`,
					props: {
						suggest: {
							typeIncludes: `hangGlideHowHigh`
						},
						createOptions: {
							type: `hangGlideHowHigh`,
							dataType: "string"
						}
					}
				},
				{
					label: "What is your greatest height flown?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideGreatestHeight`,
					props: {
						suggest: {
							typeIncludes: `hangGlideGreatestHeight`
						},
						createOptions: {
							type: `hangGlideGreatestHeight`,
							dataType: "string"
						}
					}
				},
				{
					label: "What is your greatest distance flown?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideGreatestDistance`,
					props: {
						suggest: {
							typeIncludes: `hangGlideGreatestDistance`
						},
						createOptions: {
							type: `hangGlideGreatestDistance`,
							dataType: "string"
						}
					}
				},
				{
					label: "What is your longest duration flown?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideLongestDuration`,
					props: {
						suggest: {
							typeIncludes: `hangGlideLongestDuration`
						},
						createOptions: {
							type: `hangGlideLongestDuration`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Have you or do you intend to attempt any height, distance or duration records?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasIntentAttemptHangGlideRecord`,
					props: {
						suggest: {
							typeIncludes: `hasIntentAttemptHangGlideRecord`
						},
						createOptions: {
							type: `hasIntentAttemptHangGlideRecord`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0attemptHangGlideRecordDetails`,
					props: {
						suggest: {
							typeIncludes: `attemptHangGlideRecordDetails`
						},
						createOptions: {
							type: `attemptHangGlideRecordDetails`,
							dataType: "string"
						}
					}
				},
				{
					label:
						" Have you ever flown or do you intend to fly experimental hang gliding equipment of either a manufacturer’s or your own design?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasIntentAttemptExperimentalHangGlide`,
					props: {
						suggest: {
							typeIncludes: `hasIntentAttemptExperimentalHangGlide`
						},
						createOptions: {
							type: `hasIntentAttemptExperimentalHangGlide`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0attemptExperimentalHangGlideDetails`,
					props: {
						suggest: {
							typeIncludes: `attemptExperimentalHangGlideDetails`
						},
						createOptions: {
							type: `attemptExperimentalHangGlideDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
